import React from 'react'
import NFTDropdownMenu from '../NFTDropdownMenu'
import { NavBarContainer, NavBarItem, NFTMarketPlaceMenuLink } from './styled';
import NavigationItems, { INavigationItem } from '../../data/NavigationItems';


const NFTMarketPlaceNavBar = () => {

	const mouseDownHandler = React.useCallback((route: string) => (event: React.MouseEvent) => {
		if (event.button === 1) {
			window.open(route, '_blank');
		}
	}, [])

	const renderNavigationItem = (item: INavigationItem) => {
		if (item.subItems) {
			return (
				<NavBarItem>
					<NFTDropdownMenu
						showArrow
						items={item.subItems.map(i => {
							return {
								key: i.name,
								text: i.name,
								renderItem: () => (<NFTMarketPlaceMenuLink onMouseDown={mouseDownHandler(i.route)} to={i.route}>{i.name}</NFTMarketPlaceMenuLink>),
							}
						})}
					>{item.name}</NFTDropdownMenu>
				</NavBarItem>
			)
		} else {
			return (
				<NavBarItem className='NavBarItem'>
					<NFTMarketPlaceMenuLink onMouseDown={mouseDownHandler(item.route)} to={item.route}>{item.name}</NFTMarketPlaceMenuLink>
				</NavBarItem>
			)
		}
	}

	return (
		<NavBarContainer>
			{NavigationItems.map(renderNavigationItem)}
		</NavBarContainer>
	)
}

export default NFTMarketPlaceNavBar;